<template>
  <BaseFormField
    :icon="icon"
    :label="label"
    :message="message"
  >
    <textarea
      :value="value"
      @blur="$emit('blur')"
      @input="$emit('input', $event.target.value)"
      type="text"
      :disabled="disabled"
      class="base-textarea"
    />
  </BaseFormField>
</template>

<script>
import BaseFormField from './BaseFormField.vue';

export default {
    name: 'BaseTextarea',
    components: { BaseFormField },
    props: {
        value: {
            type: String,
            default: undefined,
        },
        icon: {
            type: String,
            default: undefined,
        },
        label: {
            type: String,
            default: '',
        },
        message: {
            type: String,
            default: '',
        },
        full: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>
.base-textarea {
    height: 40px;
    padding: 16px;
    background-color: rgba(#E0E7FF, .2);
    border: 1px solid #E0E7FF;
    border-radius: 5px;
    outline: none;
    width: 100%;
    height: 150px;

    .form-field__control--has-icon & {
        padding-right: 40px;
    }
}
</style>
